import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addTask && _ctx.addTask(...args)), ["prevent"]))
  }, [
    _cache[10] || (_cache[10] = _createTextVNode(" Name:")),
    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("input", {
      class: "task-input",
      id: "name",
      type: "text",
      placeholder: "Enter task name",
      maxlength: "255",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.task) = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, _ctx.task]
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
    _cache[13] || (_cache[13] = _createTextVNode(" Due date:")),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("input", {
      class: "task-input",
      id: "due-date",
      type: "date",
      placeholder: "Enter due date",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.originalDueDate) = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, _ctx.originalDueDate]
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
    _cache[16] || (_cache[16] = _createTextVNode(" Priority:")),
    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("select", {
      class: "task-input",
      id: "priority",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priority) = $event)),
      required: ""
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("option", { value: "1" }, "Low", -1),
      _createElementVNode("option", { value: "2" }, "Medium", -1),
      _createElementVNode("option", { value: "3" }, "High", -1)
    ]), 512), [
      [_vModelSelect, _ctx.priority]
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
    _cache[19] || (_cache[19] = _createTextVNode(" Difficulty:")),
    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("select", {
      class: "task-input",
      id: "difficulty",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.difficulty) = $event)),
      required: ""
    }, _cache[8] || (_cache[8] = [
      _createElementVNode("option", { value: "1" }, "Easy", -1),
      _createElementVNode("option", { value: "2" }, "Medium", -1),
      _createElementVNode("option", { value: "3" }, "Hard", -1)
    ]), 512), [
      [_vModelSelect, _ctx.difficulty]
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
    _cache[22] || (_cache[22] = _createTextVNode(" Repeat every:")),
    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("input", {
      class: "task-input",
      id: "repeat-every",
      type: "number",
      placeholder: "Enter number of days/weeks/months/years to repeat",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.repeatEvery) = $event)),
      required: "",
      min: "1",
      step: "1"
    }, null, 512), [
      [_vModelText, _ctx.repeatEvery]
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
    _cache[25] || (_cache[25] = _createTextVNode(" Repeat interval:")),
    _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
    _withDirectives(_createElementVNode("select", {
      class: "task-input",
      id: "repeat-interval",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.repeatInterval) = $event)),
      required: ""
    }, _cache[9] || (_cache[9] = [
      _createStaticVNode("<option value=\"1\">Daily</option><option value=\"2\">Weekly</option><option value=\"3\">Monthly</option><option value=\"4\">Yearly</option><option value=\"5\">Once</option>", 5)
    ]), 512), [
      [_vModelSelect, _ctx.repeatInterval]
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
    _cache[28] || (_cache[28] = _createElementVNode("button", { type: "submit" }, "Add Task", -1))
  ], 32))
}